export class CardBrand {
  code: string;
  description: string;

  constructor() {
    this.code = '';
    this.description = '';
  }
}
